/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Clear_Presets_AriaInputs */

const en_batch_subtitle_export_clear_presets_aria = /** @type {(inputs: Batch_Subtitle_Export_Clear_Presets_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear all selected presets`)
};

const fr_batch_subtitle_export_clear_presets_aria = /** @type {(inputs: Batch_Subtitle_Export_Clear_Presets_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer tous les préréglages sélectionnés`)
};

const de_batch_subtitle_export_clear_presets_aria = /** @type {(inputs: Batch_Subtitle_Export_Clear_Presets_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle ausgewählten Voreinstellungen löschen`)
};

const it_batch_subtitle_export_clear_presets_aria = /** @type {(inputs: Batch_Subtitle_Export_Clear_Presets_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella tutti i preset selezionati`)
};

const ru_batch_subtitle_export_clear_presets_aria = /** @type {(inputs: Batch_Subtitle_Export_Clear_Presets_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить все выбранные предустановки`)
};

const es_batch_subtitle_export_clear_presets_aria = /** @type {(inputs: Batch_Subtitle_Export_Clear_Presets_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar todos los ajustes preestablecidos seleccionados`)
};

const zh_cn2_batch_subtitle_export_clear_presets_aria = /** @type {(inputs: Batch_Subtitle_Export_Clear_Presets_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除所有选定的预设。`)
};

const ja_batch_subtitle_export_clear_presets_aria = /** @type {(inputs: Batch_Subtitle_Export_Clear_Presets_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したプリセットをすべてクリア`)
};

const hi_batch_subtitle_export_clear_presets_aria = /** @type {(inputs: Batch_Subtitle_Export_Clear_Presets_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी चयनित प्रीसेट साफ़ करें`)
};

const pt_pt2_batch_subtitle_export_clear_presets_aria = /** @type {(inputs: Batch_Subtitle_Export_Clear_Presets_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar todas as predefinições selecionadas`)
};

/**
* | output |
* | --- |
* | "Clear all selected presets" |
*
* @param {Batch_Subtitle_Export_Clear_Presets_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_clear_presets_aria = /** @type {((inputs?: Batch_Subtitle_Export_Clear_Presets_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Clear_Presets_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_clear_presets_aria(inputs)
	if (locale === "de") return de_batch_subtitle_export_clear_presets_aria(inputs)
	if (locale === "it") return it_batch_subtitle_export_clear_presets_aria(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_clear_presets_aria(inputs)
	if (locale === "es") return es_batch_subtitle_export_clear_presets_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_clear_presets_aria(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_clear_presets_aria(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_clear_presets_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_clear_presets_aria(inputs)
	return en_batch_subtitle_export_clear_presets_aria(inputs)
});